export default "__VITE_ASSET__fdf537c5__"